import { renderLabelWithIcons } from 'monaco-editor/esm/vs/base/browser/ui/iconLabel/iconLabels.js';
import * as dom from 'monaco-editor/esm/vs/base/browser/dom.js';
import { MenuEntryActionViewItem } from 'monaco-editor/esm/vs/platform/actions/browser/menuEntryActionViewItem.js';
class CodiconActionViewItem extends MenuEntryActionViewItem {
    updateLabel() {
        if (this.options.label && this.label) {
            dom.reset(this.label, ...renderLabelWithIcons(this._commandAction.label ?? ''));
        }
    }
}
class ActionViewWithLabel extends MenuEntryActionViewItem {
    render(container) {
        super.render(container);
        container.classList.add('notebook-action-view-item');
        this._actionLabel = document.createElement('a');
        container.appendChild(this._actionLabel);
        this.updateLabel();
    }
    updateLabel() {
        if (this._actionLabel) {
            this._actionLabel.classList.add('notebook-label');
            this._actionLabel.innerText = this._action.label;
            this._actionLabel.title = this._action.tooltip.length ? this._action.tooltip : this._action.label;
        }
    }
}
export { ActionViewWithLabel, CodiconActionViewItem };
